import { inject, Injectable } from '@angular/core';
import type { EAgentKey, Panel, Widgets } from '@dev-fast/types';
import { Store } from '@ngxs/store';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';

import { ChangeActiveWidgets, LayoutState, OpenPanel, PingOnline, ToggleBackground } from '@app/core/state/layout';

@Injectable({
  providedIn: 'root',
})
export class LayoutTypeService {
  readonly #store = inject(Store);

  getOnlineByMode(mode: EAgentKey): Observable<number | null> {
    return this.#store.select(LayoutState.onlineByMode).pipe(map((filterFn) => filterFn(mode)));
  }

  getModesOnline(): Observable<Partial<Record<EAgentKey, number>> | null> {
    return this.#store.select(LayoutState.modesOnline);
  }

  changeActiveWidgets = (widgets: Widgets[]): Observable<void> => this.#store.dispatch(new ChangeActiveWidgets(widgets));
  openRightPanel = (panel: Panel): Observable<void> => this.#store.dispatch(new OpenPanel(panel));
  toggleBackground = (background?: string, surfaceBackground?: string): Observable<void> =>
    this.#store.dispatch(new ToggleBackground(background, surfaceBackground));

  pingOnlineByMode = (mode: EAgentKey): Observable<void> => this.#store.dispatch(new PingOnline(mode));
}
